import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getLockedUsers = async () => {
  try {
    const resp = await apiClient.get('/users/lockedUsers');
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
